import React from "react";

export default function Loader() {
  return <h1>Loading...</h1>;
}
